<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'WHISKY_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.WHISKY_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="types | toSelectOption: 'PRODUCTS.WHISKY_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <div class="in-two-columns">
    <!-- agingTime number & unit select -->

    <mat-form-field>
      <app-easy-input
        formControlName="agingTime"
        [label]="TITLE + 'AGING_TIME' | translate"
        type="number"
        min="1"
        (ngModelChange)="
          $event
            ? getCtrl('agingTimeUnit')?.setValidators(Validators.required)
            : getCtrl('agingTimeUnit')?.clearValidators()
        "
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field>
      <app-easy-select
        formControlName="agingTimeUnit"
        [label]="TITLE + 'AGING_TIME_UNIT' | translate"
        [translatePrefixForSelected]="'PRODUCTS.AGING_TIME_UNIT.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="agingTimeUnits | toSelectOption: 'PRODUCTS.AGING_TIME_UNIT.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div class="in-two-columns">
    <!-- barrelType -->

    <mat-form-field *ngIf="getCtrl('barrelType')">
      <app-easy-select
        formControlName="barrelType"
        [label]="TITLE + 'BARREL_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.BARREL_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="barrelTypes | toSelectOption: 'PRODUCTS.BARREL_TYPE.'"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- grainDistillateType -->

    <mat-form-field>
      <app-easy-select
        formControlName="grainDistillateType"
        [label]="TITLE + 'GRAIN_DISTILLATE_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.GRAIN_DISTILLATE_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          grainDistillateTypes
            | toSelectOption: 'PRODUCTS.GRAIN_DISTILLATE_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>
  </div>
</fieldset>
